import { FC, SetStateAction, Dispatch } from 'react'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import Button from '@UI/New/Button'
import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import { TeacherStudentRateInput } from '../../utils/teacherSalary'
import cn from './index.module.css'

interface Props {
  studentRates: TeacherStudentRateInput[]
  setStudentRates: Dispatch<SetStateAction<TeacherStudentRateInput[]>>
  thresholds?: boolean
}
const TeacherSalaryScheduleFields: FC<Props> = ({
  studentRates,
  setStudentRates,
  thresholds = true,
}) => {
  const rows = studentRates.length ? studentRates : [{ count: '', salary: '' }]
  const update = (index: number, field: 'count' | 'salary', value: string) =>
    setStudentRates(
      rows.map((row, i) => (i === index ? { ...row, [field]: value } : row)),
    )
  return (
    <div className={cn.ratesBlock}>
      <div className={cn.ratesTableWrapper}>
        <table className={cn.ratesTable}>
          <thead>
            <tr>
              <th>
                {thresholds
                  ? 'До какого количества учащихся'
                  : 'Количество присутствовавших'}
              </th>
              <th>Ставка за занятие</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((rate, index) => (
              <tr key={index}>
                <td>
                  <TextField
                    size="small"
                    type="number"
                    min={0}
                    max={10000}
                    value={rate.count}
                    onChange={(value) => update(index, 'count', value)}
                  />
                </td>
                <td>
                  <TextField
                    size="small"
                    type="number"
                    min={0}
                    value={rate.salary}
                    onChange={(value) => update(index, 'salary', value)}
                  />
                </td>
                <td>
                  {(rows.length > 1 || !thresholds) && (
                    <Button
                      type="button"
                      color="gray"
                      title="Удалить строку"
                      onClick={() =>
                        setStudentRates(rows.filter((_, i) => i !== index))
                      }
                    >
                      <DeleteOutlined
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
                      />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={cn.ratesActions}>
        <Button
          type="button"
          color="primary"
          leftContent={(
            <PlusOutlined
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            />
          )}
          onClick={() =>
            setStudentRates([...rows, { count: '', salary: '' }])
          }
        >
          Добавить ставку
        </Button>
      </div>
    </div>
  )
}
export default TeacherSalaryScheduleFields
